import { Component, OnInit, OnDestroy , EventEmitter, ViewChild} from '@angular/core';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalJobordersService } from 'src/app/_services/global-joborders.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { forkJoin } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { ServiceZoneService } from 'src/app/_services/service-zone.service';
import { AssetService } from 'src/app/_services/asset.service';
import { CustomersService } from 'src/app/_services/customers.service';
import { UsersService } from 'src/app/_services/admin/users.service';
import { ProfilesService } from 'src/app/_services/admin/profiles.service';
import moment from 'moment';
import { create } from 'lodash';

@Component({
  selector: 'app-filter-options',
  templateUrl: './filter-options.component.html',
  styleUrl: './filter-options.component.scss',
  standalone: false
})
export class FilterOptionsComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  jobStatusOptions: any = [];
  jobTypeOptions: any = [];
  serviceZones: any = [];
  assetTypes: any = [];
  userGroups: any = [];
  onlineUsersList: any = [];
  profilesList: any = [];

  filteredOptions: any = { 
    joTypeIds: null, 
    jobOrderStatusesId: null,
    serviceZoneIds: null, 
    assetTypeIds: null,
    customerIds: null, 
    userGroupIds: null, 
    userSkillIds: null,
    userAccessLevels: null,
    userOnlineStatuses: null,
    assetIds: null,
    createdFromDate: null,
    createdToDate: null
  };

  // Job Type
  jobTypeAssignments: any = [];
  jobTypeAssignmentsSpliced: any = [];
  showAllJobTypes: boolean = false;

  // Job Status
  jobStatusAssignments: any = [];
  jobStatusAssignmentsSpliced: any = [];
  showAllJobStatuses: boolean = false;

  // Service Zones
  serviceZoneAssignments: any = [];
  serviceZoneAssignmentsSpliced: any = [];
  showAllServiceZones: boolean = false;

  // Asset Types
  assetTypeAssignments: any = [];
  assetTypeAssignmentsSpliced: any = [];
  showAllAssetTypes: boolean = false;

  customers: any = [];
  selectedCustomer: any = null;
  showCustomer: boolean = false;
 
  // Job User Groups
  userGroupAssignments: any = [];
  userGroupAssignmentsSpliced: any = [];
  showAllUserGroups: boolean = false;

  // Profiles
  profileAssignments: any = [];
  profileAssignmentsSpliced: any = [];
  showAllProfiles: boolean = false;


  data: any; // This will hold the initial filter data passed from the parent component
  // Add this property
onApplyFilter: EventEmitter<any> = new EventEmitter();
  selectedAsset: any= null;
  assets: any[] = [];
  showAsset: boolean = false;

  // ✅ FIX: activeFilters was being used without declaration — declare it here
  dateRange!: any;
  @ViewChild('myCalendar', { static: false }) 
  private myCalendar: any;

  constructor(
    private languageTranslateService: LanguageTranslateService,
    public modalRef: BsModalRef,
    private globalJOServc: GlobalJobordersService,
    private errorUtil: ErrorUtil,
    private spinner: NgxSpinnerService,
    private serviceZonesService: ServiceZoneService,
    private assetService: AssetService,
    private customerService: CustomersService,
    private userService: UsersService,
    private profileService : ProfilesService
  ) {
    super();
  }

  ngOnInit(): void {
    console.log('FilterOptionsComponent initialized with data:', this.data);
    this.getLanguageData();
  }

  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => {
      if (Object.keys(data).length != 0) {
        this.translate = data;
        if(this.data?.filterType === 'Backlog'){ 
          this.getOtherData();
        }else if(this.data?.filterType === 'BrythumLeft'){
          this.getOtherDataForLeft();
        }else if(this.data?.filterType === 'Scheduler'){
          this.getOtherDataForScheduler();
        }
      }
    }));
  }

  getOtherData() {
    this.spinner.show();
    const sources = [
      this.globalJOServc.getJobOrderTypeStatuses(),
      this.globalJOServc.getJobOrderTypes(true),
      this.serviceZonesService.getAllServiceZones(),
      this.assetService.getTypes(true)
    ];

    forkJoin(sources).subscribe(
      ([ allJobOrderTypeStatuses, allJobOrderTypes, allServiceZones, allAssetTypes]) => {
       

        this.jobStatusOptions = allJobOrderTypeStatuses;
        this.jobStatusOptions.sort((a: any, b: any) => a.order - b.order);

        this.jobTypeOptions = allJobOrderTypes;
        this.jobTypeOptions.sort((a: any, b: any) => a.order - b.order);

        this.serviceZones = allServiceZones;
        this.serviceZones.sort((a: any, b: any) => a.name.localeCompare(b.name));

        this.assetTypes = allAssetTypes.body;
       
         // ✅ Restore previously selected filters after data is loaded
         this.restoreFilters();

        this.spinner.hide();
      }, (error) => {
        console.error("Failed to load initial data", error);
        this.spinner.hide();
      });
  }
/******* For Brythum Left Filters */
  getOtherDataForLeft() {
    this.spinner.show();
    const sources = [
      this.userService.getAlluserGroup(),
      this.serviceZonesService.getAllServiceZones(),
      this.profileService.getAllProfiles()
    ];

    forkJoin(sources).subscribe(
      ([allUserGroups, allServiceZones, allProfiles]) => {
        this.userGroups = allUserGroups;
        this.userGroups.sort((a: any, b: any) => a.order - b.order);

      this.onlineUsersList = [
      { label: this.translate?.task.fields.onlineUsers.singular, value: true },
      { label: this.translate?.task.fields.offlineUsers.singular, value: false },
    ];
    
        this.serviceZones = allServiceZones;
        this.serviceZones.sort((a: any, b: any) => a.name.localeCompare(b.name));

        this.profilesList = allProfiles;
        this.profilesList.sort((a: any, b: any) => a.name.localeCompare(b.name));
       
         // ✅ Restore previously selected filters after data is loaded
         this.restoreFilters();

        this.spinner.hide();
      }, (error) => {
        console.error("Failed to load initial data", error);
        this.spinner.hide();
      });
  }
  /******* For Brythum Scheduler Filters */
getOtherDataForScheduler() {
    this.spinner.show();
    const sources = [
       this.globalJOServc.getJobOrderTypeStatuses(),
      this.globalJOServc.getJobOrderTypes(true),
      this.serviceZonesService.getAllServiceZones()
    ];

    forkJoin(sources).subscribe(
      ([allJobOrderTypeStatuses, allJobOrderTypes, allServiceZones]) => {
        this.jobStatusOptions = allJobOrderTypeStatuses;
        this.jobStatusOptions.sort((a: any, b: any) => a.order - b.order);

        this.jobTypeOptions = allJobOrderTypes;
        this.jobTypeOptions.sort((a: any, b: any) => a.order - b.order);

      this.onlineUsersList = [
      { label: this.translate?.task.fields.onlineUsers.singular, value: true },
      { label: this.translate?.task.fields.offlineUsers.singular, value: false },
    ];
    
        this.serviceZones = allServiceZones;
        this.serviceZones.sort((a: any, b: any) => a.name.localeCompare(b.name));

       
         // ✅ Restore previously selected filters after data is loaded
         this.restoreFilters();

        this.spinner.hide();
      }, (error) => {
        console.error("Failed to load initial data", error);
        this.spinner.hide();
      });
  }

  // ✅ Add this method
restoreFilters() {
  if (!this.data) return;

  // Restore Job Status
  if (this.data.jobOrderStatusesId?.length) {
    this.data.jobOrderStatusesId.forEach((id: any) => {
      const idx = this.jobStatusOptions.findIndex((o: any) => o.id === id);
      if (idx === -1) return;
      this.jobStatusAssignments.push(this.jobStatusOptions[idx]);
      this.jobStatusOptions.splice(idx, 1);
    });
    this.jobStatusAssignmentsSpliced = this.jobStatusAssignments.slice(0, 10);
  }

  // Restore Job Type
  if (this.data.joTypeIds?.length) {
    this.data.joTypeIds.forEach((id: any) => {
      const idx = this.jobTypeOptions.findIndex((o: any) => o.id === id);
      if (idx === -1) return;
      this.jobTypeAssignments.push(this.jobTypeOptions[idx]);
      this.jobTypeOptions.splice(idx, 1);
    });
    this.jobTypeAssignmentsSpliced = this.jobTypeAssignments.slice(0, 10);
  }

  // Restore Service Zone
  if (this.data.serviceZoneIds?.length) {
    this.data.serviceZoneIds.forEach((id: any) => {
      const idx = this.serviceZones.findIndex((o: any) => o.id === id);
      if (idx === -1) return;
      this.serviceZoneAssignments.push(this.serviceZones[idx]);
      this.serviceZones.splice(idx, 1);
    });
    this.serviceZoneAssignmentsSpliced = this.serviceZoneAssignments.slice(0, 10);
  }

  // Restore Asset Type
  if (this.data.assetTypeIds?.length) {
    this.data.assetTypeIds.forEach((id: any) => {
      const idx = this.assetTypes.findIndex((o: any) => o.id === id);
      if (idx === -1) return;
      this.assetTypeAssignments.push(this.assetTypes[idx]);
      this.assetTypes.splice(idx, 1);
    });
    this.assetTypeAssignmentsSpliced = this.assetTypeAssignments.slice(0, 10);
  }

  // Restore User Groups
  if (this.data.userGroupIds?.length) {
    this.data.userGroupIds.forEach((id: any) => {
      const idx = this.userGroups.findIndex((o: any) => o.id === id);
      if (idx === -1) return;
      this.userGroupAssignments.push(this.userGroups[idx]);
      this.userGroups.splice(idx, 1);
    });
    this.userGroupAssignmentsSpliced = this.userGroupAssignments.slice(0, 10);
  }

  // Restore User Service Zones
 if (this.data.userServiceZoneIds?.length) {
    this.data.userServiceZoneIds.forEach((id: any) => {
      const idx = this.serviceZones.findIndex((o: any) => o.id === id);
      if (idx === -1) return;
      this.serviceZoneAssignments.push(this.serviceZones[idx]);
      this.serviceZones.splice(idx, 1);
    });
    this.serviceZoneAssignmentsSpliced = this.serviceZoneAssignments.slice(0, 10);
  }

  // ✅ FIX: was this.data.profilesList.forEach — profilesList is not on data.
  //    The saved filter stores profile names in userAccessLevels, match by name.
  if (this.data.userAccessLevels?.length) {
    this.data.userAccessLevels.forEach((name: any) => {
      const idx = this.profilesList.findIndex((o: any) => o.name === name);
      if (idx === -1) return;
      this.profileAssignments.push(this.profilesList[idx]);
      this.profilesList.splice(idx, 1);
    });
    this.profileAssignmentsSpliced = this.profileAssignments.slice(0, 10);
  }

  // Restore Online Status
  if (this.data.userOnlineStatuses) {
    this.filteredOptions.userOnlineStatuses = this.data.userOnlineStatuses;
  }
// ✅ Restore Customer — id + display name
  if (this.data.customerIds) {
    this.filteredOptions.customerIds = this.data.customerIds;
    // ✅ Restore the display object so autocomplete shows the name
    if (this.data.customerName) {
      this.selectedCustomer = {
        id  : this.data.customerIds,
        name: this.data.customerName
      };
    }
  }

  // ✅ Restore Asset — id + display name
  if (this.data.assetIds) {
    this.filteredOptions.assetIds = this.data.assetIds;
    // ✅ Restore the display object so autocomplete shows the name
    if (this.data.assetName) {
      this.selectedAsset = {
        id  : this.data.assetIds,
        name: this.data.assetName
      };
    }
  }

  // ✅ Restore Created Date Range
  if (this.data.createdFromDate && this.data.createdToDate) {
    this.filteredOptions.createdFromDate = this.data.createdFromDate;
    this.filteredOptions.createdToDate   = this.data.createdToDate;
    // ✅ Restore p-calendar range array so the calendar shows the selection
    this.dateRange = [
      new Date(this.data.createdFromDate),
      new Date(this.data.createdToDate)
    ];
  }
}

  onCancelClick() {
    this.modalRef.hide();
  }

  // ─── Job Type ───────────────────────────────────────────
  onAddJOType() {
    const foundIdx = this.jobTypeOptions.findIndex((item: any) => item.id === this.filteredOptions.joTypeIds);
    if (foundIdx === -1) return;

    this.jobTypeAssignments.push(this.jobTypeOptions[foundIdx]);
    this.jobTypeAssignmentsSpliced = this.showAllJobTypes
      ? [...this.jobTypeAssignments]
      : this.jobTypeAssignments.slice(0, 10);

    this.jobTypeOptions.splice(foundIdx, 1);
    this.filteredOptions.joTypeIds = null;
  }

  removeJobType(jt: any, i: number) {
    this.jobTypeAssignments.splice(this.jobTypeAssignments.findIndex((item: any) => item.id === jt.id), 1);
    this.jobTypeOptions.push(jt);
    this.jobTypeOptions.sort((a: any, b: any) => a.order - b.order);
    this.jobTypeAssignmentsSpliced = this.showAllJobTypes
      ? [...this.jobTypeAssignments]
      : this.jobTypeAssignments.slice(0, 10);
  }

  // ─── Job Status ─────────────────────────────────────────
  onAddJobStatus() {
    const foundIdx = this.jobStatusOptions.findIndex((item: any) => item.id === this.filteredOptions.jobOrderStatusesId);
    if (foundIdx === -1) return;

    this.jobStatusAssignments.push(this.jobStatusOptions[foundIdx]);
    this.jobStatusAssignmentsSpliced = this.showAllJobStatuses
      ? [...this.jobStatusAssignments]
      : this.jobStatusAssignments.slice(0, 10);

    this.jobStatusOptions.splice(foundIdx, 1);
    this.filteredOptions.jobOrderStatusesId = null;
  }

  removeJobStatus(js: any) {
    this.jobStatusAssignments.splice(this.jobStatusAssignments.findIndex((item: any) => item.id === js.id), 1);
    this.jobStatusOptions.push(js);
    this.jobStatusOptions.sort((a: any, b: any) => a.order - b.order);
    this.jobStatusAssignmentsSpliced = this.showAllJobStatuses
      ? [...this.jobStatusAssignments]
      : this.jobStatusAssignments.slice(0, 10);
  }

  // ─── Service Zone ────────────────────────────────────────
  onAddServiceZone() {
    const foundIdx = this.serviceZones.findIndex((item: any) => item.id === this.filteredOptions.serviceZoneIds);
    if (foundIdx === -1) return;

    this.serviceZoneAssignments.push(this.serviceZones[foundIdx]);
    this.serviceZoneAssignmentsSpliced = this.showAllServiceZones
      ? [...this.serviceZoneAssignments]
      : this.serviceZoneAssignments.slice(0, 10);

    this.serviceZones.splice(foundIdx, 1);
    this.filteredOptions.serviceZoneIds = null;
  }

  removeServiceZone(sz: any) {
    this.serviceZoneAssignments.splice(this.serviceZoneAssignments.findIndex((item: any) => item.id === sz.id), 1);
    this.serviceZones.push(sz);
    this.serviceZones.sort((a: any, b: any) => a.name.localeCompare(b.name));
    this.serviceZoneAssignmentsSpliced = this.showAllServiceZones
      ? [...this.serviceZoneAssignments]
      : this.serviceZoneAssignments.slice(0, 10);
  }

  onAddUserGroup() {
  const foundIdx = this.userGroups.findIndex((item: any) => item.id === this.filteredOptions.userGroupIds);
    if (foundIdx === -1) return;

    this.userGroupAssignments.push(this.userGroups[foundIdx]);
    this.userGroupAssignmentsSpliced = this.showAllUserGroups
      ? [...this.userGroupAssignments]
      : this.userGroupAssignments.slice(0, 10);

    this.userGroups.splice(foundIdx, 1);
    this.filteredOptions.userGroupIds = null;
  }

  removeUserGroup(ug: any) {
  this.userGroupAssignments.splice(
    this.userGroupAssignments.findIndex((item: any) => item.id === ug.id), 1
  );
  this.userGroups.push(ug);
  // ✅ Guard against undefined name
  this.userGroups.sort((a: any, b: any) =>
    (a.name ?? '').localeCompare(b.name ?? '')
  );
  this.userGroupAssignmentsSpliced = this.showAllUserGroups
    ? [...this.userGroupAssignments]
    : this.userGroupAssignments.slice(0, 10);
}

  onAddProfile() {
    const foundIdx = this.profilesList.findIndex((item: any) => item.name === this.filteredOptions.userAccessLevels);
    if (foundIdx === -1) return;

    this.profileAssignments.push(this.profilesList[foundIdx]);
    this.profileAssignmentsSpliced = this.showAllProfiles
      ? [...this.profileAssignments]
      : this.profileAssignments.slice(0, 10);

    this.profilesList.splice(foundIdx, 1);
    this.filteredOptions.userAccessLevels = null;
  }

  removeProfile(profile: any) {
    this.profileAssignments.splice(this.profileAssignments.findIndex((item: any) => item.name === profile.name), 1);
    this.profilesList.push(profile);
    this.profilesList.sort((a: any, b: any) => a.name.localeCompare(b.name));
    this.profileAssignmentsSpliced = this.showAllProfiles
      ? [...this.profileAssignments]
      : this.profileAssignments.slice(0, 10);
  }


  // ─── Show More Toggle ────────────────────────────────────
  onShowMoreToggle(category: string) {
    if (category === 'jobType') {
      this.showAllJobTypes = !this.showAllJobTypes;
      this.jobTypeAssignmentsSpliced = this.showAllJobTypes
        ? [...this.jobTypeAssignments]
        : this.jobTypeAssignments.slice(0, 10);

    } else if (category === 'jobStatus') {
      this.showAllJobStatuses = !this.showAllJobStatuses;
      this.jobStatusAssignmentsSpliced = this.showAllJobStatuses
        ? [...this.jobStatusAssignments]
        : this.jobStatusAssignments.slice(0, 10);

    } else if (category === 'serviceZone') {
      this.showAllServiceZones = !this.showAllServiceZones;
      this.serviceZoneAssignmentsSpliced = this.showAllServiceZones
        ? [...this.serviceZoneAssignments]
        : this.serviceZoneAssignments.slice(0, 10);
    
    } else if (category === 'assetType') {
      this.showAllAssetTypes = !this.showAllAssetTypes;
      this.assetTypeAssignmentsSpliced = this.showAllAssetTypes
        ? [...this.assetTypeAssignments]
        : this.assetTypeAssignments.slice(0, 10);
    } else if (category === 'userGroup') {
      this.showAllUserGroups = !this.showAllUserGroups;
      this.userGroupAssignmentsSpliced = this.showAllUserGroups
        ? [...this.userGroupAssignments]
        : this.userGroupAssignments.slice(0, 10);
    } else if (category === 'profile') {
      this.showAllProfiles = !this.showAllProfiles;
      this.profileAssignmentsSpliced = this.showAllProfiles
        ? [...this.profileAssignments]
        : this.profileAssignments.slice(0, 10);
    }
  }

  // ─── Asset Type ──────────────────────────────────────────
onAddAssetType() {
  const foundIdx = this.assetTypes.findIndex((item: any) => item.id === this.filteredOptions.assetTypeId);
  if (foundIdx === -1) return;

  this.assetTypeAssignments.push(this.assetTypes[foundIdx]);
  this.assetTypeAssignmentsSpliced = this.showAllAssetTypes
    ? [...this.assetTypeAssignments]
    : this.assetTypeAssignments.slice(0, 10);

  this.assetTypes.splice(foundIdx, 1);
  this.filteredOptions.assetTypeId = null;
}

removeAssetType(at: any) {
  this.assetTypeAssignments.splice(this.assetTypeAssignments.findIndex((item: any) => item.id === at.id), 1);
  this.assetTypes.push(at);
  this.assetTypes.sort((a: any, b: any) => a.label.localeCompare(b.label));
  this.assetTypeAssignmentsSpliced = this.showAllAssetTypes
    ? [...this.assetTypeAssignments]
    : this.assetTypeAssignments.slice(0, 10);
}
/******** */

  /**************************************** Autocomplete Customer ****************************************/
  public getCustomer(event: any) {
    const query = event.query;

    if (query && query.length > 2) {
      const sortModel = [];
      const parameters = { colId: "name", sort: "asc" };
      sortModel.push(parameters);

      const serverRequest = {
        startRow: 0,
        pageSize: 25,
        filterModel: null,
        sortModel: sortModel,
      };

      super.push(
        this.customerService.getCustomerList(query, serverRequest).subscribe((data: any) => {
            this.customers = data.body.data;
          })
      );
}
  }

  /******************************************** on select customer value ******************************************/
  public selectCustomerValue(valueCust: any) {
    var value = valueCust.value ? valueCust.value : valueCust;
    console.log("selected customer", value);

    this.selectedCustomer = value;
    this.filteredOptions.customerIds = value.id;
    //this.getCustomerDetails(value.id)
    this.customers = [];
  }

  /******************************************** On Got Selected Customer ******************************************/
  public selectCustomerFromTable(value: any) {

   // var value = valueCust.value ? valueCust.value : valueCust;
  this.selectedCustomer = value;
    console.log("selected customer", value);
   this.filteredOptions.customerIds = value.id
    this.customers = [];
   
    this.closeCustomerView();
  }
 

  /******************************************** close customer table ******************************************/
  public closeCustomerView() {
    this.showCustomer = false;
  }

  /******************************************** on remove customer ******************************************/
  public clearValue(what: string) {
    if (what === "customer") {
      this.selectedCustomer = null;
      this.customers = [];
      this.filteredOptions.customerIds = null;
    } else if (what === "asset") {
      this.selectedAsset = null;
      this.assets = [];
      this.filteredOptions.assetIds = null;
    }
  }

   onvalidCustomer() {
    if (this.filteredOptions.customerIds == null || this.filteredOptions.customerIds == '') {
      this.selectedCustomer = null;
    }
  }

/******************************************** Show Table Dynamic Picklist ******************************************/
  public showTable(what: string) {
    if (what === "customer") {
      this.showCustomer = true;
    }

    if (what === "asset") {
      this.showAsset = true;
    }
  }
 /******************************************** on select asset value ******************************************/
 public selectAssetFromTable(valueAsset: any) {

  var value = valueAsset.value ? valueAsset.value : valueAsset;

  console.log(valueAsset,"selected asset", value);
 this.filteredOptions.assetIds = value.id
  this.assets = [];
 
  this.closeAssetView();
}

 /******************************************** close asset table ******************************************/
 public closeAssetView() {
  this.showAsset = false;
}
getAsset(event: any) {
   const query = event.query;
    if (query != null && query.length > 2) {
      this.push(
        this.assetService.getAssetsByName(query).subscribe(
          (data) => {
            this.assets = data.data;
          },
          (err) => this.errorUtil.setErrorMessage(err)
        )
      );
    }
}

public gotSelectedAsset(valData: any) {
    console.log("selected asset", valData);

    var val = valData.value ? valData.value : valData;
    // set selected asset
    let asset: any = {}
    if (val) {
      asset.id = val.id;
      asset.name = val.assetName ? val.assetName : val.name;
    }
    this.selectedAsset = asset;
    // get the asset
    this.selectAssetFromTable(val);
    this.showAsset = false;
  }

 public onvalidAsset() {
    if (this.filteredOptions.assetIds == null || this.filteredOptions.assetIds == '') {
      this.selectedAsset = null;
    }
  }






onConfirmClick() {
  console.log('Applying filters with current selections:', this.filteredOptions)
  
  var filterData: any = {};
  if(this.data?.filterType === 'Backlog'){
   filterData = {
    joTypeIds: this.jobTypeAssignments.map((item: any) => item.id),
    serviceZoneIds: this.serviceZoneAssignments.map((item: any) => item.id),
    assetTypeIds: this.assetTypeAssignments.map((item: any) => item.id),
    jobOrderStatuses: this.jobStatusAssignments.map((item: any) => item.name),
    jobOrderStatusesId: this.jobStatusAssignments.map((item: any) => item.id),
    filterType: this.data?.filterType,
    customerIds: this.filteredOptions.customerIds ?? null,
    customerName : this.selectedCustomer?.name        ?? null,  // ✅ for restore
    createdFromDate: this.filteredOptions.createdFromDate ?? null,
    createdToDate: this.filteredOptions.createdToDate ?? null,
  }
}else if(this.data?.filterType === 'BrythumLeft'){
   filterData = {
    userGroupIds: this.userGroupAssignments.map((item: any) => item.id),
    userServiceZoneIds: this.serviceZoneAssignments.map((item: any) => item.id),
    userAccessLevels: this.profileAssignments.map((item: any) => item.name),
    userOnlineStatuses: this.filteredOptions.userOnlineStatuses ?? null,
    filterType: this.data?.filterType,
  }
}else if(this.data?.filterType === 'Scheduler'){
   filterData = {
    jobOrderStatusesId: this.jobStatusAssignments.map((item: any) => item.id),
    joTypeIds: this.jobTypeAssignments.map((item: any) => item.id),
    jobOrderStatuses: this.jobStatusAssignments.map((item: any) => item.name),
    customerIds: this.filteredOptions.customerIds ?? null,
    customerName : this.selectedCustomer?.name        ?? null,  // ✅ for restore

    serviceZoneIds: this.serviceZoneAssignments.map((item: any) => item.id),
    filterType: this.data?.filterType,
    assetIds: this.filteredOptions.assetIds ?? null,
    assetName    : this.selectedAsset?.name            ?? null,  // ✅ for restore

    createdFromDate: this.filteredOptions.createdFromDate ?? null,
    createdToDate: this.filteredOptions.createdToDate ?? null,
  }
}
  this.onApplyFilter.emit(filterData); // ✅ emit before hiding
  this.modalRef.hide();

}
onClear() {
  // Move all assigned items back to options
  this.jobTypeOptions.push(...this.jobTypeAssignments);
  this.jobStatusOptions.push(...this.jobStatusAssignments);
  this.serviceZones.push(...this.serviceZoneAssignments);
  this.assetTypes.push(...this.assetTypeAssignments);

  // Clear assignments
  this.jobTypeAssignments = [];
  this.jobStatusAssignments = [];
  this.serviceZoneAssignments = [];
  this.assetTypeAssignments = [];

  // Reset spliced arrays
  this.jobTypeAssignmentsSpliced = [];
  this.jobStatusAssignmentsSpliced = [];
  this.serviceZoneAssignmentsSpliced = [];
  this.assetTypeAssignmentsSpliced = [];

  // Reset filtered options
  this.filteredOptions = { joTypeIds: null, jobOrderStatusesId: null ,serviceZoneIds: null, assetTypeId: null};

   // Emit cleared filters
   this.onApplyFilter.emit(null); // ✅ emit null or empty object to indicate filters are cleared
  this.modalRef.hide();
}

public onDateChange(event: any) {
    if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
      this.filteredOptions.createdFromDate = moment(this.dateRange[0]).format("YYYY-MM-DD");
      this.filteredOptions.createdToDate = moment(this.dateRange[1]).format("YYYY-MM-DD");
      this.myCalendar.hideOverlay();
        }

    if (event === null) {
      this.filteredOptions.createdFromDate = null;
      this.filteredOptions.createdToDate = null;
      
    }
  }

}
